import { useMutation } from '@tanstack/react-query';
import { clientConfig } from 'env/config';

type Props = {
  coworkerId: number;
  token: string;
};

export const sendNexudusLastActive = async ({ coworkerId, token }: Props) => {
  const config = clientConfig();

  const response = await fetch(`${config.authServiceUrl}/api/lastactive`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ coworkerId }),
  });

  if (!response.ok) {
    throw new Error('Failed to update last active date');
  }

  return response.json();
};

export const useNexudusLastActiveMutation = ({ coworkerId, token }: Props) => {
  return useMutation({
    mutationFn: () => sendNexudusLastActive({ coworkerId, token }),
    onError: (error) => {
      console.error('Error updating last active date:', error);
    },
  });
};
